import {z} from 'zod';
import {
	editRemovesFromFilter,
	getDefaultFilters,
	type EditRemovesFromFilterParams,
	type GetDefaultFiltersParams,
} from '@netx/core-next/schema';
import {
	GroupUserSchema,
	type IGroupUser,
	GroupUserField,
} from './groupUserSchema';
import {UserFilterSchema} from '@netx/core-user-next/schema/user/userFilter';

export const GroupUserFilterSchema = UserFilterSchema;

export const GroupUsersFilterableField = GroupUserFilterSchema.keyof().enum;

export const GROUP_USER_FILTERABLE_FIELDS = Object.values(
	GroupUsersFilterableField,
);

export type GroupUsersFilter = z.infer<typeof GroupUserFilterSchema>;

/** will return the filters passed in if valid/specified, otherwise will return the defaults for the invalid/unspecified */
export const getGroupUsersDefaultFilters = (
	params?: Omit<GetDefaultFiltersParams<GroupUsersFilter>, 'filterableFields'>,
): GroupUsersFilter =>
	getDefaultFilters({
		...params,
		filterableFields: GROUP_USER_FILTERABLE_FIELDS,
	});

/** given the original data, the new data, and the current filters, determine if the record should still be included in the filtered list */
export const groupUserEditRemovesFromFilter = (
	params: Omit<
		EditRemovesFromFilterParams<IGroupUser, GroupUsersFilter>,
		'schema'
	>,
) =>
	editRemovesFromFilter({
		...params,
		schema: GroupUserSchema,
	});
